import React from 'react'
import { Link } from 'react-router-dom'
import { jt, t } from 'ttag'

import { browserHistory } from '../../Routes'

const UsageTips = ({ selectedItem }) => {
  const boldMagicLink = <strong>{t`Magic Link`}</strong>
  const systemName = dynamicValues.systemName
  const budgetName = dynamicValues.budgetTitle
  const summarizeTitle = <strong>{t`Summarize`}</strong>
  const items = [
    {
      title: t`Bringing Users Under Management`,
      body: (
        <div key="usermgmt">
          <div className="step1">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/d1a9b283-0ab8-4901-bb80-c971f1203970.jpg"
              className="img-responsive"
            />
            <p>{t`Log in and click on the educator button in the management toolbar at the top of the screen.`}</p>
          </div>

          <div className="step2">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/b2c760f5-7c5c-49e6-8605-6b244650b235.jpg"
              className="img-responsive"
            />
            <p>{jt`Click on the ${boldMagicLink} to copy it to the clipboard.`}</p>
          </div>

          <div className="step3">
            <p>{jt`Distribute your ${boldMagicLink} via email or post it in Google Classroom or other sites your students visit. `}</p>
          </div>
        </div>
      )
    },
    {
      title: t`Professional Development`,
      body: (
        <div key="pdev">
          <p>{t`Did you know you have access to our free Level I professional development course in the ${systemName}? In this in-depth tutorial, we’ll review:`}</p>

          <p>{t`The development is delivered in four parts, including pre and post evaluations. However, no part needs to be done all at once, so you can complete it at your own pace.`}</p>
        </div>
      )
    },
    {
      title: t`Self Assessments`,
      body: (
        <div key="selfassess">
          <p>{t`Find the jobs you’re most likely to enjoy`}</p>
          <p>{t`One of our most popular self-assessments is the Interest Profiler. By answering 30 or 60 questions about their interests, students can find a listing of occupations which might bring satisfaction. To get them going quickly:`}</p>
          <div className="step2">
            Tap on <strong>Discover Possibilities</strong> and select{' '}
            <strong>Interest Profiler</strong>
          </div>

          <div className="step2">
            <img
              className="img-responsive"
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/3a0465ae-788a-4282-b49d-040219fd5cf8.jpg"
            />
            <br />
            <br />
            {t`Follow the directions on-screen to work through the questions.`}
          </div>
          <div className="step2">
            <img
              className="img-responsive"
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/411f0103-0632-4273-b5eb-14e77c7b0787.png"
            />
            {jt`At the end, click ${summarizeTitle} to see personalized results`}
          </div>
          <p>{t`With these results, students can continue their exploration into colleges, job openings, and other relevant information to help inform their plan.`}</p>
        </div>
      )
    },
    {
      title: t`Budget Your Life`,
      body: (
        <div>
          <p>{t`Students will often make choices based on a singular factor, and not having considered the whole picture. The ${budgetName} tool allows students to "Choose Your Lifestyle" and find out how big a salary that lifestyle might require. `}</p>
          <p>{t`Sometimes your students may not know what they want to be when they grow up but they know how they want to live. Here's how to build a lifestyle budget:`}</p>
          <div className="step1">
            Tap on <strong>Discover Possibilities</strong> and select{' '}
            <strong>{budgetName}</strong>
          </div>
          <div className="step2">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/1b5dab41-7205-4ab4-bb89-a8f00597b80a.jpg"
              className="img-responsive"
            />
            We suggest the "<strong>Choose Your Lifestyle</strong>" budget. It's a great
            conversation starter!
          </div>
          <div className="step3">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/7b2b5818-6bc3-4d6f-b158-7f8d706bbad2.gif"
              className="img-responsive"
            />
            {t`Work through the questions to find out how much they need.`}
          </div>

          <div className="with-border note-color">
            <strong>{t`Hot tip!`}</strong>{' '}
            {t`Remember you can change the dollar values that appear on the right side of the screen.`}
          </div>

          <p>{t`Once they have worked through the questions, they will see the annual salary they need to support that lifestyle, and can see a list of occupations that pay that much. Also, once they have completed the budget, any listing of occupations will indicate to the student with a piggy bank icon those occupations that meet their budget.`}</p>
        </div>
      )
    },
    {
      title: t`Create and assign a lesson`,
      body: (
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube-nocookie.com/embed/Zmj1xAP-f14?rel=0"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
          <p>First, Let’s Build a Lesson</p>

          <div className="step1">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/5acd53be-c707-4d33-90a0-2fbc7ca847b9.jpg"
              className="img-responsive"
            />
            <p>
              Go to the <strong>Management toolbar</strong> tab and select{' '}
              <strong>Lessons </strong>
            </p>
          </div>

          <div className="step2">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/47abc9b4-b63f-4d92-b8d5-20d37e22c3b8.jpg"
              className="img-responsive"
            />
            <p>
              Click the <strong>Create a Lesson</strong> a button and follow the on-screen
              instructions to create the lesson
            </p>
          </div>

          <div className="step3">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/08a7a46e-3976-4dc5-b829-18af0d00b50e.jpg"
              className="img-responsive"
            />
            <p>
              Within the lesson, as you add new tasks, you’ll see you can create tasks
              that track many items in the system -- including the{' '}
              <strong>Interest Profiler</strong> and <strong>Budget</strong> that we had
              reviewed in the past few weeks.
            </p>
          </div>

          <div className="with-border note-color">
            Note: When you’re exploring, you may notice some things that are grayed out or
            have a lock icon. These features are extras that are included subscribers. If
            you are interested in finding out more about subscriptions, click here
          </div>
        </div>
      )
    },
    {
      title: t`Run reports`,
      body: (
        <div>
          <div>
            <p>
              You have students under management and they're actively using the
              *|HEADED2SYS|*. The easiest way to see what they're up to is with our
              Dashboard Report. In this email, we'll show you how to bring up the report
              and drill down to the user for further details.
            </p>
          </div>
          <div className="step1">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/b967982c-b583-470a-8c78-b99d83658337.gif"
              className="img-responsive"
            />
            <p>Use the filter box to select the users you want to report on.</p>
          </div>
          <div className="step2">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/19ba4680-5a81-4eb2-a66c-6ac18db6faa2.gif"
              className="img-responsive"
            />
            <p>
              Click the <strong>Report</strong> button, and select the{' '}
              <strong>Dashboard</strong> report option.
            </p>
          </div>
          <div className="step3">
            <img
              src="https://gallery.mailchimp.com/5c17da901219c657ed5b87432/images/8c0f265d-65fc-40ee-bf71-c2de7ba3b59d.jpg"
              className="img-responsive"
            />
            <p>
              The dots in each column will represent the status of a particular activity.
              Green is complete, white is in progress, and a dash indicates the user
              hasn't started yet.
            </p>
          </div>
          <p>
            The report can be exported to PDF or Excel, so you can easily use it within
            your SIS or other data system.
          </p>
        </div>
      )
    }
  ]
  const moveTo = idx => {
    return () => browserHistory.push(`/educators/usageTips/${idx}`)
  }
  const getContent = () => {
    const selectedItemIdx = parseInt(selectedItem)
    const data = items[selectedItemIdx]

    return data
  }

  return (
    <div className={`usage-tip-container ${selectedItem ? `opened` : `closed`}`}>
      <div className="left-panel">
        <ol className="prefixed-counter">
          {items.map((i, idx) => (
            <li
              key={idx}
              className={` ${idx == selectedItem ? `currently-selected` : ``}`}
              onClick={moveTo(idx)}>
              <a href="javascript:void(0)" onClick={moveTo(idx)}>
                <span className={`item-text`}>{i.title}</span>
              </a>
            </li>
          ))}
        </ol>
        <div className="text-center">
          {selectedItem && (
            <Link
              to="/educators/usageTips"
              className="btn btn-default btn-small no-style">
              {t`Close`}
            </Link>
          )}
        </div>
      </div>
      <div className="right-panel">
        <h3 className="section-heading">{getContent()?.title}</h3>
        <div>{getContent()?.body ?? null}</div>
      </div>
    </div>
  )
}

export default UsageTips
